import type { BadgeProps } from '@buffer-mono/popcorn'

import { ApprovalBadge } from './ApprovalBadge'
import { DraftBadge } from './DraftBadge'
import { usePostData } from '../PostCard/PostCardContext'

import type { JSX } from 'react'

/**
 * Display the appropriate badge based on the post status.
 */
export const PostStatusBadge = (
  props: Pick<BadgeProps, 'size'>,
): JSX.Element | null => {
  const { status } = usePostData()

  if (status === 'needs_approval') {
    return <ApprovalBadge {...props} />
  }

  if (status === 'draft') {
    return <DraftBadge {...props} />
  }

  return null
}
